import { Radio, Typography } from '@up-riac/bespoke-ui';
import React from 'react';
import { AnalyticsContext } from 'src/lib/AnalyticsContext';
import { useTheme } from 'src/lib/ThemeContext';

export const HeaderMobileMenuSettingsPage = () => {
  const { darkMode, setDarkMode } = useTheme();
  const { sendHotjarEvent } = React.useContext(AnalyticsContext);
  return <>
    <div className='px-5 py-4'>
      <Radio
        label={<Typography weight='bold' heading size='xs' color='text'>Color theme</Typography>}
        description={<Typography color='text'>Switch between light and dark themes.</Typography>}
        value={darkMode}
        onChange={(value) => {
          sendHotjarEvent('UX-mobile_menu_theme_changed');
          setDarkMode(value as 'light' | 'dark' | 'system-default');
        }}
        className='flex flex-col gap-1'
        excludeFromTabOrder
      >
        <Radio.Option value='light'>Light</Radio.Option>
        <Radio.Option value='dark'>Dark</Radio.Option>
        <Radio.Option value='system-default'>System theme (default)</Radio.Option>
      </Radio>
    </div>
  </>;
};
